import Component from './Component';
import Fragment from './Fragment';
import View from './View';
import Layout from './Layout';
import TopLayout from './TopLayout';
export {Component, Fragment, View, Layout, TopLayout};

exports.renderFragment = function renderFragment(helper, getFragment, fragmentName, data) {
    var Fragment = getFragment(fragmentName);
    if (!Fragment) {
        throw new Error('Fragment not found: ' + fragmentName);
    }
    if (!Fragment.prototype.render) {
        var fragmentFn = Fragment;
        return fragmentFn(helper, data);
    }
    var fragment = new Fragment(helper);
    if (fragment.resolveDependencies) {
        fragment.resolveDependencies();
    }
    fragment.render(data);
    if (fragment.parent) {
        return renderFragment(helper, getFragment, fragment.parent, {
            title: fragment.title,
            content: fragment.$container,
        });
    }
    return fragment;
};

exports.renderComponent = function renderComponent(helper, getComponent, componentName, data, properties) {
    var Component = getComponent(componentName);
    if (!Component) {
        throw new Error('Component not found: ' + componentName);
    }
    var component = new Component(helper, data.$container);
    if (component.resolveDependencies) {
        component.resolveDependencies();
    }
    delete data.$container;
    component.$container.attr('data-component', componentName);
    component.init(properties);
    if (properties) {
        component.$container.attr('data-component-properties', JSON.stringify(properties));
    }
    component.firstRender();
    component._initElements();
    var renderResult = component.render(data);
    if (renderResult instanceof Promise) {
        return renderResult.then(() => component);
    }
    return component;
};

exports.renderView = function renderView(helper, getView, viewName, data, properties) {
    var View = getView(viewName);
    if (!View) {
        throw new Error('View not found: ' + viewName);
    }
    var view = new View(helper);
    if (view.resolveDependencies) {
        view.resolveDependencies();
    }
    view.$container.attr('data-view', viewName);
    view.init(properties);
    view._initElements();
    if (properties) {
        view.$container.attr('data-view-properties', JSON.stringify(properties));
    }
    if (view.parent) {
        view.$container.attr('data-view-parent', view.parent);
    }

    return Promise.resolve(view.render(data)).then((result) => {
        if (!view.parent) {
            return view;
        }
        return renderView(helper, getView, view.parent, {
            title: view.title,
            content: view.$container
        });
        /*
        return renderView(helper, getView, view.parent, {
            title: view.title,
            content: view.$container
        });*/
    });
};
